export default function TableInfo({ rowCount, totalRowCount }) {
  return (
    <div className="table-info">
      Showing {rowCount} of {totalRowCount} records
    </div>
  );
}
